import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ConfigSystemParams } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';

@Component({
  selector: 'app-demo-dashboard',
  templateUrl: './demo-dashboard.component.html',
  styleUrls: ['./demo-dashboard.component.scss']
})

export class DemoDashboardComponent implements AfterViewInit, OnInit {
  
  get showHowdyGo() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesDemonstrationsShowHowdyGo, false); }

  constructor(
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService
  ) {

  }
  
  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(){
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
